import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  TextareaAutosize,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

class ReasonCancelRDV extends Component {
  render() {
    const { errors, dataSource } = this.props;
    let listReasons = dataSource["canceledReasons"];
    let keyOther = listReasons?.length;
    return (
      <>
        {/*Annuler RDV 1/3 - desktop*/}
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#212121",
            padding: 20
          }}
        >
          <Typography
            style={{
              width: "100%",
              padding: 4,
              textAlign: "center"
            }}
          >
            Pour quelle raison annulez vous ce rendez-vous?
          </Typography>
          <FormControl component="fieldset" error={!!errors.motif}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
            >
              <Grid container spacing={0}>
                <Grid item xs={12} sm={6}>
                  {listReasons.map((item, key) => {
                    return (
                      <FormControlLabel
                        key={key}
                        value={item.id}
                        name={item.nom}
                        control={<Radio color="primary" />}
                        label={item.nom}
                        onChange={this.props.handleOnChange}
                      />
                    );
                  })}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    key={keyOther}
                    value={listReasons.slice(-1)[0] + 1}
                    name={"Autre raisons :"}
                    control={<Radio color="primary" />}
                    label={"Autre raisons :"}
                    onChange={this.props.handleOnChange}
                  />
                  <TextareaAutosize
                    onChange={this.props.handleChangeDescription}
                    name="description"
                    style={{
                      height: 60,
                      width: "98%",
                      border: "solid 1px #9DB2BF",
                      borderRadius: "4px",
                      padding: 4
                    }}
                    placeholder="Exprimez-vous librement"
                    multiline
                    variant="outlined"
                  />
                  {errors && errors?.description && (
                    <FormHelperText>{errors.motif}</FormHelperText>
                  )}
                </Grid>
              </Grid>
            </RadioGroup>
            {errors && !errors?.description && (
              <FormHelperText>{errors.motif}</FormHelperText>
            )}
          </FormControl>
        </Box>
      </>
    );
  }
}

ReasonCancelRDV.propTypes = {
  dataSource: PropTypes.any,
  errors: PropTypes.any,
  handleOnChange: PropTypes.func,
  handleChangeDescription: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    isShowLang: state.configuration.isShowLang || false,
    configuration: state.configuration
  };
};

export default connect(mapStateToProps)(ReasonCancelRDV);
